import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from "react-router-dom";
import { Container, Box, Typography, Card, CardContent, Grid, Stack, Button } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { userData } from '../../../common/spinLoader';
import AddIcon from '@mui/icons-material/Add';
import { updatemaxCapFactor, fetchingStorageCapacity, fetchingNewStorageCapacity } from '../resourceCommonAPIs';
import { toast } from 'react-toastify';
import { NO_DATA_AVAILABLE } from '../../../common/constants';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { SaveIcon } from '../../../common/icons';

function StorageCapacity() {
    const navigate = useNavigate()
    // let arr = [];
    const [arr, setArr] = useState([])
    const [fetchLLEISCapacity, setFetchLLEISCapacity] = useState();
    const [newLLEISCapacity, setNewLLEISCapacity] = useState();
    const [showAddLleISBtn, setShowAddLleISBtn] = useState(true);
    const [pageSize, setPageSize] = React.useState(10);
    const [successSaveCapacity, setSuccessSaveCapacity] = useState([]);

    useEffect(() => {
        fetchingStorageCapacity(setFetchLLEISCapacity)
        fetchingNewStorageCapacity(setNewLLEISCapacity)
    }, []);
    useEffect(() => {
        if (successSaveCapacity) {
            if (successSaveCapacity.status === 'SUCCESS') {
                fetchingStorageCapacity(setFetchLLEISCapacity)
                fetchingNewStorageCapacity(setNewLLEISCapacity)
                setShowAddLleISBtn(true);
                toast.success(successSaveCapacity?.description);
                navigate('/resourcedashboard/storageCapacity');
            }
            else {
                toast.error(successSaveCapacity?.description)
            }
        }
    }, [successSaveCapacity]);

    const addLLEISBtnApi = () => {
        let res = [];
        const temp = newLLEISCapacity === null || newLLEISCapacity?.length === 0 ? toast.info(NO_DATA_AVAILABLE) :
            newLLEISCapacity?.map((data) => {
                let tempData = { ...data }
                tempData.maxCapFactor = 0
                return {
                    'stakeholderURN': tempData.urn,
                    'stakeholderType': tempData.categoryName,
                    'landArea': tempData.categoryName === 'LLE' ? tempData?.lleMasters[0]?.landArea : tempData?.temporaryStorageMasters[0]?.landArea,
                    'maxCapFactor': tempData.maxCapFactor,
                    'storageCapacity': '',
                }
            })
        res = temp?.filter(el => {
            return !fetchLLEISCapacity?.find(element => {
                return element.stakeholderURN === el.stakeholderURN;
            });
        });
        let finalData = [...res, ...fetchLLEISCapacity]
        setFetchLLEISCapacity(finalData);
        setShowAddLleISBtn(false);
    }
    const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow }
        if (arr.length !== 0) {
            let objExist = arr?.filter(obj => obj.stakeholderURN === updatedRow.stakeholderURN);
            if (objExist?.length > 0) {
                objExist[0].maxCapFactor = updatedRow.maxCapFactor
            } else arr.push(updatedRow)
        } else arr.push(updatedRow)
        return updatedRow

    }
    const SaveChipping = (e) => {
        e.preventDefault();
        (arr.some(item => item.landArea === null)) ?
            toast.error("Land Area Not Present")
            :
            updatemaxCapFactor(arr, setSuccessSaveCapacity, setArr);
            setShowAddLleISBtn(true);
    }
    const columns = [
        { field: 'stakeholderURN', headerName: 'Stakeholder URN', width: 200 },
        { field: 'stakeholderType', headerName: 'Stakeholder Type', width: 200 },
        { field: 'landArea', headerName: 'LandArea ', width: 200 },
        { field: 'maxCapFactor', headerName: 'Maximum Capacity Factor', width: 190, type: 'number', editable: true },
        { field: 'storageCapacity', headerName: 'Storage Capacity', width: 190 },
    ];
    return (
        <>
            <Helmet>
                <title> Add Storage Capacity | ABEPL </title>
            </Helmet>
            <Container maxWidth="xl">
                <Stack direction={{ xs: 'column', sm: 'row' }} mb={1} justifyContent="space-between">
                    <Typography variant="h4" gutterBottom>
                        Add Storage Capacity
                    </Typography>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} justifyContent="flex-end" mb={1}>
                        <Button variant="contained" startIcon={<SaveIcon />} onClick={(e) => SaveChipping(e)} >
                            Save
                        </Button>
                        {showAddLleISBtn && <Button variant="contained" startIcon={<AddIcon />} onClick={() => addLLEISBtnApi()}>
                            ADD
                        </Button>}
                    </Stack>

                </Stack>
                <br></br>
                <Box sx={{
                    height: 450, width: '100%',
                    justifyContent: "center",
                    alignItems: "center",
                    '& .super-app-theme--header': {
                        wordWrap: 'break-word',
                        wordBreak: 'break-all',
                        whiteSpace: 'initial',
                    },
                    '& .MuiDataGrid-cell--editable': {
                        bgcolor: (theme) =>
                            theme.palette.mode === 'dark' ? '#376331' : 'rgb(217 243 190)',
                    },
                }}>
                    {fetchLLEISCapacity && (fetchLLEISCapacity.length > 0)
                        ?
                        <DataGrid
                            rows={fetchLLEISCapacity}
                            columns={columns}
                            getRowId={(row) => row.stakeholderURN}
                            processRowUpdate={processRowUpdate}
                            experimentalFeatures={{ newEditingApi: true }}
                            pageSize={pageSize}
                            onPageSizeChange={(newPage) => setPageSize(newPage)}
                            components={{ Toolbar: QuickSearchToolbar }}
                        />
                        :
                        <Typography display='flex' alignItems="center" justifyContent="center" sx={{ fontWeight: "bold" }}>{NO_DATA_AVAILABLE}</Typography>
                    }

                </Box>
            </Container>
        </>
    )
}

export default StorageCapacity